import React from 'react';
import { Icon } from 'src/components/shared';

import * as Styles from 'src/styles/circle-checkmark.module.scss';

const CircleCheckmark = ({ size = 18 }) => {
    return (
        <div
            style={{
                height: size + size * 0.2,
                width: size + size * 0.2,
                minWidth: size + size * 0.2,
            }}
            className={`${Styles.checkmark}`}
        >
            <Icon color="mint" size={size} name="pv-checkmark" />
        </div>
    );
};

export default CircleCheckmark;
